export default async ({ store }) => {
  await [
    //  'blog/clear',
    'jumbotron/CLEAR_JUMBOTRON',
    'pageContent/clear',
    //  'products/clear',
    //  'providers/clear',
    //  'providers/clearCurrent',
    //  'rateChanges/clear',
    //  'search/clearCarInsuranceAddons',
    //  'user/clearAdditionalDriver',
    //  'user/clearCustomer',
    //  'user/clearJointCustomer',
    //  'utils/clearAddress',
    'utils/clearFormError',
    'utils/clearFormErrors'
  ].forEach(mutation => store.commit(mutation));
};
